<template>
    <div class="img-picker-pagination clearfix">
        <div v-if="total" class="img-picker-pagination-total">{{ text }}</div>
        <v-pagination style="float: right;" :total="total" :count="count" @change="onChange" />
    </div>
</template>

<script>
export default {
    name: 'ReplyPagination',
    props: {
        total: {
            type: Number,
            default: 0
        },
        count: {
            type: Number,
            default: 15,
        },
        text: {
            type: String,
            default: ''
        }
    },
    methods: {
        onChange(page) {
            this.$emit('change', page);
        }
    }
};
</script>

<style>
.img-picker-pagination {
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    padding: 15px;
    background-color: #edeff2;
    border: none;
}

.img-picker-pagination .v-pagination__total {
    display: none;
}

.img-picker-pagination-total {
    float: left;
    line-height: 30px;
}
</style>
